import React, {useEffect, useState} from 'react'
import FetchUtil from "../../../util/FetchUtil";
import ConfigUtil from "../../../util/ConfigUtil";
import DateUtil from "../../../util/DateUtil";
import {InputText} from "primereact/inputtext";
import ErrorInfoComponent from "../../general/ErrorInfoComponent";
import DHDialog from "../../general/DHDialog";

export default function TournamentPlayerEventOperatorSelectDialog({eventOperatorId, showEinzeltplayers, showDoppelplayers, callBackOnSelect, callBackOnClose}) {

    const [infoMessage, setInfoMessage] = useState(undefined);
    const [errorMessage, setErrorMessage] = useState(undefined);

    let [showAllRows, setShowAllRows] = useState(false);

    let [players, setPlayers] = useState([]);
    let [tournaments, setTournaments] = useState([]);
    let [search, setSearch] = useState("");

    useEffect(() => {
        FetchUtil.fetchGet(ConfigUtil.getConfig().resourceUrls.tournament + "/eventoperator/players/" + eventOperatorId,
            json => {
                setTournaments(json.tournaments);
                setPlayers(json.players);
            },
            responseNotOk => {
                setErrorMessage("Fehler beim Laden: " + responseNotOk.message);
            },
            error => {
                setErrorMessage("Fehler beim Laden: " + error.message);
            }
        );
    }, [eventOperatorId]);

    function existSearchInPlayername(player) {
        for (const dto of player.eventOperatorPlayerNameTournamentDtos) {
            if (dto.name.toUpperCase().includes(search.toUpperCase())) {
                return true;
            }
        }
        return false;
    }

    function getTournamentName(tournamentId) {
        let array = tournaments.filter(tournament => tournament.id === tournamentId);
        if (array.length === 0) {
            return undefined;
        }
        return array[0].bezeichnung;
    }

    function getTournamentBeginn(tournamentId) {
        let array = tournaments.filter(tournament => tournament.id === tournamentId);
        if (array.length === 0) {
            return undefined;
        }
        return array[0].beginn;
    }

    const getRows = () => {
        if (eventOperatorId === null || eventOperatorId === undefined) {
            return "";
        }
        let rows = [];
        let counter = 0;
        for (let i = 0; i < players.length; i++) {
            let player = players[i];
            if( !showEinzeltplayers || !showDoppelplayers ) {
                if( showEinzeltplayers && !player.einzelspieler) {
                    continue;
                }
                if( showDoppelplayers && !player.doppelspieler) {
                    continue;
                }
            }
            let modulo = i % 2;
            let currentStyle = modulo === 0 ? {backgroundColor: "#f2f2f2"} : {};
            let namenArray = [];
            let name = [];
            let count = 0;
            let eventOperatorPlayerNameTournamentDtos = player.eventOperatorPlayerNameTournamentDtos;
            eventOperatorPlayerNameTournamentDtos.sort(function(a, b) {
                return new Date(a.timestamp) < new Date(b.timestamp) ? 1 : -1;
            });
            for (const dto of eventOperatorPlayerNameTournamentDtos) {
                let tournamentName = getTournamentName(dto.tournamentId);
                let tournamentBeginn = getTournamentBeginn(dto.tournamentId);
                // sobald nicht vorhanden, handelt es sich um ein Gold-Turnier, daher nicht anzeigen
                if (tournamentName === undefined || tournamentBeginn === undefined) {
                    continue;
                }
                count++;
                if (count > 3 && !showAllRows) {
                    break;
                }
                name.push(<div style={{marginBottom: 5}}>{DateUtil.localDateTimeToString(tournamentBeginn)} - {dto.name}<br/>{tournamentName}</div>);
                if (!namenArray.includes(dto.name)) {
                    namenArray.push(dto.name);
                }
            }
            name.push(<div style={{color: "blue", cursor: "pointer"}} onClick={() => setShowAllRows(!showAllRows)}>{showAllRows ? "...weniger anzeigen" : "...mehr anzeigen..."}</div>);
            if (namenArray.length === 0) {
                // keine Turniernamen. Entweder harter Fehler oder onlyDoppelturnier und kein Doppelturnier gefunden.
                continue;
            }
            if (search === "" || existSearchInPlayername(player) || player.idShort.toUpperCase().includes(search.toUpperCase())) {
                counter++;
                rows.push(<div className="grid" key={"key_player_" + player.idShort} style={{marginTop: "5px", ...currentStyle}}>
                    <div className="col-fixed" style={{width: 40}}>{counter}.</div>
                    <div className="col-fixed" style={{width: 100, cursor: "pointer"}} onClick={() => callBackOnSelect(player.idShort, namenArray)}>{player.idShort}</div>
                    <div className="col" style={{width: "100%"}}>{name}</div>
                </div>);
            }
        }
        return rows;
    }

    return <DHDialog title="Spielerauswahl" onClose={() => callBackOnClose()} showCloseButton={true} comp={<>
        <ErrorInfoComponent infoMessage={infoMessage} errorMessage={errorMessage} onClearInfoMessage={() => setInfoMessage(undefined)} onClearErrorMessage={() => setErrorMessage(undefined)}/>
        <div className="grid" style={{marginTop: 10}}>
            <div className="col-fixed" style={{width: 150}}>Filter:</div>
            <div className="col"><InputText style={{width: 330}} value={search}
                                            onChange={(e) => setSearch(e.target.value)}/></div>
        </div>
        <div className="grid" style={{marginTop: "10px"}}>
            <div className="col" style={{fontWeight: "bold"}}>Anzahl Spieler: {players.length}</div>
        </div>
        <div className="grid" style={{marginTop: "5px", fontWeight: "bold", borderBottom: "1px solid black"}}>
            <div className="col-fixed" style={{width: 40}}>#</div>
            <div className="col-fixed" style={{width: 100}}>SpielerId</div>
            <div className="col-fixed" style={{width: 140}}>Eventbeginn</div>
            <div className="col" style={{width: "100%"}}>Name</div>
        </div>
        {getRows()}
    </>}/>
}
